import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { loadConfig } from './config';
import { getToken } from './auth';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import PlantDetail from './pages/PlantDetail';
import AdminDashboard from './pages/AdminDashboard';
import AdminPlantForm from './pages/AdminPlantForm';
import AdminGalleryUpload from './pages/AdminGalleryUpload';
import GuidesIndex from './pages/GuidesIndex';
import GuideArticle from './pages/GuideArticle';
import AboutMe from './pages/AboutMe';
import Login from './pages/Login';
import './styles.css';

export default function App() {
  const [ready, setReady] = useState(false);
  const [token, setToken] = useState(null);

  useEffect(() => {
    // The whole site is gated behind this promise, so it must always
    // settle. Previously a rejection anywhere in here (a failed
    // config.json fetch, a Cognito pool built from missing config) left
    // `ready` false and the site stuck on the loading state for good.
    let cancelled = false;
    loadConfig()
      .catch(() => {})
      .then(() => getToken().catch(() => null))
      .then(t => { if (!cancelled) setToken(t); })
      .catch(() => {})
      .finally(() => { if (!cancelled) setReady(true); });
    return () => { cancelled = true; };
  }, []);

  if (!ready) return <div className="loading">Loading</div>;

  return (
    <BrowserRouter>
      <a className="skip-link" href="#main">Skip to content</a>
      <Header token={token} setToken={setToken} />
      <main className="main-content" id="main">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/plant/:id" element={<PlantDetail token={token} />} />
          <Route path="/admin" element={
            token ? <AdminDashboard token={token} /> : <Login setToken={setToken} />
          } />
          <Route path="/admin/plant/new" element={
            token ? <AdminPlantForm token={token} /> : <Login setToken={setToken} />
          } />
          <Route path="/admin/plant/:id/edit" element={
            token ? <AdminPlantForm token={token} /> : <Login setToken={setToken} />
          } />
          <Route path="/admin/gallery" element={
            token ? <AdminGalleryUpload token={token} /> : <Login setToken={setToken} />
          } />
          <Route path="/guides" element={<GuidesIndex />} />
          <Route path="/guides/:slug" element={<GuideArticle />} />
          <Route path="/about" element={<AboutMe />} />
          <Route path="/login" element={<Login setToken={setToken} />} />
        </Routes>
      </main>
      <Footer />
    </BrowserRouter>
  );
}
